export const REFRESH_INTERVAL = 60000 * 15;
export const NEW_VIDEO_STYLE_TIMEOUT = 10000;
export const NUMBER_OF_VIDEOS = 10;
export const SEARCH_DEBOUNCE_TIME = 500;
